import React from 'react';
interface CreditNoteHeaderProps {
  company: {
    name: string;
    address: string[];
    phone: string;
    email: string;
    gstRegNo: string;
  };
  creditNote: {
    number: string;
    issueDate: string;
    bookingRef: string;
    customerRef: string;
    staff: string;
  };
}
export function CreditNoteHeader({
  company,
  creditNote
}: CreditNoteHeaderProps) {
  return <>
      {/* Top Header */}
      <div className="flex justify-between items-start mb-8" data-id="element-202">
        {/* Left: Company Info */}
        <div className="flex-1" data-id="element-203">
          <div className="w-16 h-16 bg-gradient-to-br from-blue-600 to-blue-700 rounded-lg mb-4 flex items-center justify-center shadow-md" data-id="element-204">
            <span className="text-white font-bold text-xl" data-id="element-205">MT</span>
          </div>
          <h1 className="text-xl font-bold text-neutral-900 mb-2" data-id="element-206">
            {company.name}
          </h1>
          <div className="text-xs text-neutral-600 space-y-0.5 leading-relaxed" data-id="element-207">
            {company.address.map((line, i) => <p key={i} data-id="element-208">{line}</p>)}
            <p className="mt-2" data-id="element-209">Tel: {company.phone}</p>
            <p data-id="element-210">Email: {company.email}</p>
            <p data-id="element-211">GST Reg. No.: {company.gstRegNo}</p>
          </div>
        </div>

        {/* Right: Credit Note Metadata Box */}
        <div className="bg-neutral-50 border border-neutral-200 rounded-lg p-5 min-w-[320px] shadow-sm" data-id="element-212">
          <div className="space-y-2" data-id="element-213">
            <div className="flex justify-between" data-id="element-214">
              <span className="text-xs font-medium text-neutral-600" data-id="element-215">
                Credit Note No.:
              </span>
              <span className="text-xs font-semibold text-neutral-900" data-id="element-216">
                {creditNote.number}
              </span>
            </div>
            <div className="flex justify-between" data-id="element-217">
              <span className="text-xs font-medium text-neutral-600" data-id="element-218">
                Issue Date:
              </span>
              <span className="text-xs text-neutral-900" data-id="element-219">
                {creditNote.issueDate}
              </span>
            </div>
            <div className="flex justify-between" data-id="element-220">
              <span className="text-xs font-medium text-neutral-600" data-id="element-221">
                Booking Ref:
              </span>
              <span className="text-xs text-neutral-900" data-id="element-222">
                {creditNote.bookingRef}
              </span>
            </div>
            <div className="flex justify-between" data-id="element-223">
              <span className="text-xs font-medium text-neutral-600" data-id="element-224">
                Customer Ref:
              </span>
              <span className="text-xs text-neutral-900" data-id="element-225">
                {creditNote.customerRef}
              </span>
            </div>
            <div className="h-px bg-neutral-200 my-2" data-id="element-226" />
            <div className="flex justify-between" data-id="element-227">
              <span className="text-xs font-medium text-neutral-600" data-id="element-228">
                Staff:
              </span>
              <span className="text-xs font-semibold text-neutral-900" data-id="element-229">
                {creditNote.staff}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Centered Title */}
      <div className="text-center mb-6" data-id="element-230">
        <h2 className="text-2xl font-bold text-neutral-900 tracking-tight" data-id="element-231">
          CREDIT NOTE
        </h2>
      </div>
    </>;
}